<template>
  <div>
    <div v-if="!dataLoaded">
      <b-card title="لیست لینک ها">
        <b-skeleton type="button"></b-skeleton>
        <b-skeleton-table
          :rows="10"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        ></b-skeleton-table>
      </b-card>
    </div>
    <div v-if="dataLoaded">
      <b-card title="لیست لینک ها" v-if="shepaLink != null">
        <b-alert
          variant="danger"
          :show="UserCOnfirmed < 1 && UserCOnfirmed != -1"
        >
          <p>
            اطلاعات کاربری شما تایید نشده است. تا زمانی که اطلاعات خود را تایید
            نکنید امکان دریافت درگاه وجود ندارد
          </p>
          <p>
            برای تایید اطلاعات خود
            <a href="/user/conf">اینجا</a> کلیک کنید
          </p>
        </b-alert>
        <b-button
          v-if="UserCOnfirmed == 1"
          class="mr-3"
          variant="success"
          href="/newShepaLink"
          >لینک جدید</b-button
        >

        <b-table
        responsive
          style="width: 100%"
          striped
          hover
          show-empty
          empty-text="آیتمی جهت نمایش وجود ندارد"
          :fields="fields"
          :items="links"
        >
          <template v-slot:cell(details)="row">
            <b-link variant="success" :href="'shepaLink/' + row.item.id"
              >جزییات</b-link
            >
          </template>
          <template v-slot:cell(easypay_url)="row">
            <b-link
              variant="success"
              target="_blank"
              :href="row.item.gateway.website + '/' + row.item.easypay_url"
              >{{
                row.item.gateway.website + "/" + row.item.easypay_url
              }}</b-link
            >
          </template>
        </b-table>
      </b-card>
      <b-card v-if="shepaLink == null">
        <b-alert show variant="warning"
          >برای ثبت کالا در شپالینک نیاز به درگاه شخصی دارید، می توانید با
          استفاده از این از این <a href="/newspgateway">لینک</a> نسبت به درخواست درگاه شخصی اقدام
          نمایید</b-alert
        >
      </b-card>
    </div>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import AddCard from "../BankCards/AddCard";
import sessionHelper from "../../helpers/sessionHelper";
export default {
  name: "ShepaLink",
  components: { AddCard },
  data() {
    return {
      dataLoaded: false,
      pgw: {},
      userCards: {},
      fields: [
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "status.title",
          label: "وضعیت",
        },
        {
          key: "easypay_url",
          label: "لینک",
        },
        {
          key: "details",
          label: "عملیات",
        },
      ],
      links: [],
      UserCOnfirmed: -1,
      shepaLink: null,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "شپا لینک" }]);
    httpHelper.getData("userconf/avg").then((res) => {
      this.UserCOnfirmed = parseFloat(res.result);
    });
    this.getShepalink();
  },
  methods: {
    getShepalink() {
      httpHelper.getData("paymentgateways/shepalink").then((res) => {
        this.dataLoaded = true;
        if (res.result.length > 0) {
          this.shepaLink = res.result[0];
          if (this.shepaLink == null) {
            this.getaccounts();
          } else {
            httpHelper.getData("easypay").then((res) => {
              this.links = res.result;
            });
          }
        }
      });
    },
    getaccounts() {
      this.pgw.shepalink = sessionHelper.getUser().mobile;
      // this.pgw.shepalink = this.pgw.shepalink.substr(
      //   0,
      //   this.pgw.shepalink.indexOf("@")
      // );
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result.map((item) => {
          return {
            text: item.shaba_number,
            value: item.id,
          };
        });
      });
    },
    savePGW() {
      httpHelper.postData("userconf/bandp", this.pgw).then((res) => {
        this.getShepalink();
      });
    },
  },
};
</script>